import { Injectable, inject, signal } from '@angular/core';
import { ClaimReportDeviceRepository } from '../repositories/claim-report-device.repository';
import { ClaimReportDevice, ClaimReportDocumentItem } from '../types/claim-report-device';

function flatten(items: ClaimReportDocumentItem[]): ClaimReportDocumentItem[] {
  return items.flatMap((item) => [item, ...flatten(item.subitems ?? [])]);
}

@Injectable()
export class ClaimReportDeviceService {
  private readonly repository = inject(ClaimReportDeviceRepository);

  readonly devices = signal<ClaimReportDevice[]>([]);
  readonly isLoading = signal(false);
  readonly error = signal<unknown>(null);

  async load(documentId: string): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);
    try {
      const items = await this.repository.load(documentId);
      this.devices.set(
        flatten(items ?? [])
          .filter((item) => item.product.rental)
          .map((item) => ({
            id: item.id,
            key: item.product.key,
            name: item.product.description1,
          }))
      );
    } catch (e) {
      this.error.set(e);
      throw e;
    } finally {
      this.isLoading.set(false);
    }
  }
}
